import React from 'react';
import { FaStar } from 'react-icons/fa';
import './SpotlightedPost.scss';

interface SpotlightedPostProps {
  children: React.ReactNode;
  isSpotlighted: boolean;
  spotlightEndTime?: Date | string;
  className?: string;
  showIndicator?: boolean; // Show spotlight indicator in header
  feedType?: 'default' | 'location' | 'spotlight'; // Different styles for different feeds
}

/**
 * Wrapper component that applies spotlight styling to posts
 * Automatically adds visual effects, animations, and badges
 */
export const SpotlightedPost: React.FC<SpotlightedPostProps> = ({
  children,
  isSpotlighted,
  spotlightEndTime,
  className = '',
  showIndicator = false,
  feedType = 'default',
}) => {
  // Check if spotlight is still active
  const isActive = isSpotlighted && (!spotlightEndTime || new Date(spotlightEndTime) > new Date());

  return (
    <div
      className={`
        post-container
        ${isActive ? 'spotlighted' : ''}
        ${className}
        ${feedType !== 'default' ? `${feedType}-feed` : ''}
      `}
      data-spotlighted={isActive}
    >
      {/* Shimmer effect overlay */}
      {/* {isActive && <div className="spotlight-shimmer" />} */}

      {/* Optional spotlight indicator in post header */}
      {showIndicator && isActive && (
        <div className="spotlight-indicator">
          <FaStar />
        </div>
      )}

      {/* Post content */}
      {children}
    </div>
  );
};

export default SpotlightedPost;
